import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Converts a string to a URL/storage-safe slug.
 * Removes accents, converts to lowercase, replaces spaces and special chars with underscores.
 */
export function slugify(text: string): string {
  return text
    .normalize('NFD')                    // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, '')     // Remove diacritics
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')         // Replace non-alphanumeric with _
    .replace(/^_+|_+$/g, '');            // Trim leading/trailing underscores
}
